import { SyntheticEvent } from 'react';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import {
  Button,
  Header,
  Segment,
  Form,
  Input,
  Label,
  Grid,
} from 'semantic-ui-react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { v4 as uuid } from 'uuid';
import { Inward, InwardInitialState } from '../../../../app/models/inwards';
import { Activity } from '../../../../app/models/activity';
import { useStore } from '../../../../app/stores/store';
import VerifyFileUpload from '../../Receiving/VerifyImageUpload/VerifyFileUpload';
import MyTextArea from '../../../../app/common/form/MyTextArea';
import { FileUploadInterface } from '../../../../app/models/Profile';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import { FileType } from '../../../MediaAssets/Details/FileUpload';
import { Image } from 'semantic-ui-react';
import agent from '../../../../app/api/agent';

function InwardRequestForm() {
  const { activityStore, userStore, dashboardStore, commonStore } = useStore();
  //   const {
  //     activityRegistry,
  //     activityRegistryBarcode,
  //     activityRegistryQrcode,
  //     activityRegistryrfid,
  //   } = activityStore;

  const [InwardState, setInwardState] = useState<any>(InwardInitialState);
  const [imageUrl, setimageUrl] = useState<FileUploadInterface[]>([]);
  const [selectedItemLevel, setSelectedItemLevel] = useState<
    Activity | undefined
  >();
  const [assetId, setAssetId] = useState('');
  const [inwardRequestErr, setInwardRequestErr] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  useEffect(() => {
    if (dashboardStore.dashboard.verifyImageUrl.length > 0) {
      setimageUrl(dashboardStore.dashboard.verifyImageUrl);
    }
  }, [dashboardStore.dashboard.verifyImageUrl]);

  useEffect(() => {
    let Filtered = activityStore.selectedActivity;
    // if (ActivityDetails !== undefined) {
    //   Filtered = ActivityDetails;
    // } else if (ActivityDetails2 !== undefined) {
    //   Filtered = ActivityDetails2;
    // } else if (ActivityDetails3 !== undefined) {
    //   Filtered = ActivityDetails3;
    // } else if (ActivityDetails4 !== undefined) {
    //   Filtered = ActivityDetails4;
    // } else {
    //   Filtered = undefined;
    // }
    if (!Filtered || !assetId) {
      setInwardState(InwardInitialState);
      return;
    }

    //  all assets
    if (Filtered !== undefined && Filtered.inwards.length < 1) {
      setSelectedItemLevel(Filtered);
      // state to all assets
      const getDate = new Date().toISOString().slice(0, 10).split('-'); //create an array
      const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; //setting the date time
      const newArr = {
        ...InwardState,
        id: uuid(),
        InwardRequestId: uuid(),
        assetId: Filtered?.id,
        inwardDateTime: _date,
        assetName: Filtered?.title,
        // element: Filtered?.element,
        // totalNumberOfElement: Filtered?.number_of_element,
        borrowerName:
          userStore?.user?.username !== undefined
            ? userStore.user?.username
            : '',
      };
      setInwardRequestErr(false);
      setInwardState(newArr);
    } else if (Filtered !== undefined && Filtered.inwards.length > 0) {
      setInwardRequestErr(true);
      setInwardState(InwardInitialState);
    } else {
      setInwardRequestErr(false);
      setInwardState(InwardInitialState);
    }
    // eslint-disable-next-line
  }, [activityStore.selectedActivity]);

  const changeSelectOptionHandler = async (e: SyntheticEvent, data: any) => {
    setInwardState(InwardInitialState);
    const response = await activityStore?.getInwardRequestItem(
      data.value?.trim(),
    );
    if (typeof response === 'string' && response !== '') {
      setInwardRequestErr(true);
      setErrMsg(response || 'Inward Request not possible for this asset');
    } else {
      setErrMsg('');
      setInwardRequestErr(false);
      let Filtered = activityStore.selectedActivity;
      setSelectedItemLevel(activityStore.selectedActivity);
      const getDate = new Date().toISOString().slice(0, 10).split('-'); //create an array
      const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; //setting the date time
      const newArr = {
        ...InwardState,
        id: uuid(),
        InwardRequestId: uuid(),
        assetId: Filtered?.id,
        inwardDateTime: _date,
        assetName: Filtered?.title,
        // element: Filtered?.element,
        // totalNumberOfElement: Filtered?.number_of_element,
        borrowerName:
          userStore?.user?.username !== undefined
            ? userStore.user?.username
            : '',
      };
      setInwardState(newArr);
    }
    setAssetId(data.value);
  };

  const handleFormSubmit = async (inward: Inward) => {
    setAssetId('');
    if (selectedItemLevel !== undefined && InwardState !== undefined) {
      const newArr = {
        ...InwardState,
        inwardDateTime: new Date().toISOString(),
        isActive: true,
        files: imageUrl,
      };
      const itemArr = {
        ...selectedItemLevel,
        order_tracking: 'Inward Request Raised',
        inwards: [newArr],
        assignedUsers: [],
      };

      // DeliveryStore.createDelivery(itemArr)
      activityStore.createInward(itemArr);
      sendRespectiveEmail('created', itemArr.language, 'Inward Request', '');
      commonStore.updateHistoryAlonePOST(
        `Inward request for ${itemArr.title} is received from ${userStore.user?.displayName}`,
        itemArr?.id,
        undefined,
        true,
        true,
      );
      await agent.InventoryDelivery.OrderTrackingStatus(
        activityStore.selectedActivity?.id,
        'Inward Request Raised',
      );
      setInwardState(InwardInitialState);
    }

    dashboardStore.setVerifyUrlResponse([]);
    dashboardStore.dashboard.valueForL3Orders = 'Verify';
    //    setInwardState(newArr)
  };
  const handleCancel = () => {
    dashboardStore.setVerifyUrlResponse([]);
    setInwardState(InwardInitialState);
    setAssetId('');
  };

  return (
    <Segment
      clearing
      style={{
        Responsive: true,
        padding: '20px',
        width: 'min(100% - 30px, 1200px)',
        margin: '20px auto',
      }}
      responsive={true}
    >
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content="Inward Return"
        sub
        color="grey"
      />
      <Formik
        enableReinitialize
        initialValues={InwardState}
        onSubmit={(values) => handleFormSubmit(values)}
        validationSchema={Yup.object({
          assetId: Yup.string().required(),
        })}
      >
        {({ handleSubmit, values }) => (
          <Form
            className="inwardRequestForm"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Header />
            <Header />
            <Grid columns={2}>
              <Grid.Column>
                <Form.Field
                  control={Input}
                  label="Asset ID"
                  name="assetId"
                  placeholder="AssetID"
                  value={assetId}
                  onChange={changeSelectOptionHandler}
                />
                {inwardRequestErr && errMsg !== '' && (
                  <Label basic color="red" style={{ marginTop: '-13px' }}>
                    {errMsg}
                  </Label>
                )}
              </Grid.Column>

              <Grid.Column>
                <Form.Field
                  label="Asset Name"
                  control={Input}
                  style={{ opacity: '0.65', pointerEvents: 'none' }}
                  name="assetName"
                  placeholder="--Asset Name--"
                  value={InwardState?.assetName || ''}
                />
              </Grid.Column>
            </Grid>
            {/* <Grid columns={2} style={{ marginTop: '0px' }}>
              <Grid.Column>
                <Form.Field
                  label="Element"
                  control={Input}
                  disabled
                  name="element"
                  placeholder="--Element--"
                  value={InwardState?.element || ''}
                />
              </Grid.Column>
              <Grid.Column>
                <Form.Field
                  label="Total Number of Elements"
                  control={Input}
                  disabled
                  name="totalNumberOfElement"
                  placeholder="--Element Count--"
                  value={InwardState?.totalNumberOfElement || ''}
                />
              </Grid.Column>
            </Grid> */}
            <Grid columns={2} style={{ marginTop: '0px' }}>
              <Grid.Column>
                <Form.Field
                  label="Borrower Name"
                  control={Input}
                  style={{ opacity: '0.65', pointerEvents: 'none' }}
                  name="borrowerName"
                  placeholder="--Borrower--"
                  value={InwardState?.borrowerName || ''}
                />
              </Grid.Column>
              <Grid.Column>
                <Form.Field
                  style={{ opacity: '0.65', pointerEvents: 'none' }}
                  label="Date"
                  name="inwardDateTime"
                  placeholderText="Select Date"
                  value={InwardState.inwardDateTime || ''}
                  control={Input}
                  showTimeSelect
                  timeCaption="Time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                />
              </Grid.Column>
            </Grid>
            <div style={{ marginBlock: '16px' }}>
              <MyTextArea
                label="Comments"
                name="comments"
                placeholder="Comments"
                rows={3}
              />

              {dashboardStore.dashboard.verifyImageUrl.map((f: FileType) => {
                return (
                  <>
                    <Image
                      src={
                        f.url.match(/\.(gif|jpe?g|tiff?|png|webp|bmp|svg)$/i)
                          ? f.url
                          : '/assets/documents.jpg'
                      }
                      alt="file upload"
                      style={{
                        display: 'inline-block',
                        marginRight: '20px',
                        marginBottom: '10px',
                        height: '100px',
                      }}
                    />
                    <p
                      style={{
                        color: 'black',
                        alignItems: 'center',
                        width: '100px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {f.fileName}
                    </p>
                  </>
                );
              })}
            </div>

            {assetId !== '' && !inwardRequestErr ? (
              <VerifyFileUpload nameData="inward" itemIdForInward={assetId} />
            ) : null}

            <Button.Group floated="right">
              <Button onClick={handleCancel}> Cancel </Button> <Button.Or />
              <Button
                disabled={values.assetId === ''}
                type="submit"
                content="Submit"
                positive
              >
                Submit{' '}
              </Button>
            </Button.Group>
          </Form>
        )}
      </Formik>
    </Segment>
  );
}
export default observer(InwardRequestForm);
